import cookiesChecker from './cookiesChecker';
import tracking from './tracking';

export default function(){
	cookiesChecker();
	tracking();
}